export default __webpack_public_path__ + "static/5-safety-tips-when-connecting-to-wifi-overseas-laptop-7e3b7361b4f67197182adf17a15fc320.jpg";